import { HttpInterceptorFn, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingService } from './loading.service';

/** Exclude these URLs from triggering the global loading overlay (avoids blocking first click on init) */
const EXCLUDED_URL_PATTERNS = ['/assets/i18n/', '/assets/'];

function isExcludedFromGlobalOverlay(url: string): boolean {
  const path = url.split('?')[0].split('#')[0];
  return /\/api\/v1\/user$/.test(path);
}

function shouldShowLoading(url: string): boolean {
  if (isExcludedFromGlobalOverlay(url)) {
    return false;
  }
  return !EXCLUDED_URL_PATTERNS.some((pattern) => url.includes(pattern));
}

export const loadingInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const loadingService = inject(LoadingService);
  const showOverlay = shouldShowLoading(req.url);

  if (showOverlay) {
    loadingService.increment();
  }

  return next(req).pipe(
    finalize(() => {
      if (showOverlay) loadingService.decrement();
    })
  );
};
